import {IImportService} from "../../services/IImportService";
import {ImportField} from "./ImportField";
import {Asset} from "../../entities/Asset";

export class ImportModel<T> {
    csvData:any[] = [];
    entities:any[] = [];
    errorEntities:any[] = [];
    okEntities:any[] = [];
    errors:string[] = [];
    errorsCount:number = 0;
    skipped:any[] = [];
    importColumns:string[] = [];
    importFields:ImportField[] = [];
    requiredImportFields:ImportField[] = [];
    optionalImportFields:ImportField[] = [];
    static $inject = ['$q'];
    constructor(public $q:ng.IQService, public importService:IImportService<T>){
        var aoeuaoeuaoeuaeouaoeu = 3;
    }
    getColumns():string[]{
        var temp:string[] = [];
        if(this.csvData.length > 0){
            for(var col in this.csvData[0]){
                temp.push(col);
            }
            this.importColumns = temp;
        }
        return temp;
    }
    getImportFields():ng.IPromise<any>{
        if(this.importFields.length > 0)
            return this.$q.when();
        else
            return this.importService.getImportFields().then((data)=>{
                for(var i=0; i<data.length; i++) {
                    var importField:ImportField = ImportField.parseJson(data[i]);
                    if(importField.required)
                        this.requiredImportFields.push(importField);
                    else
                        this.optionalImportFields.push(importField);
                    this.importFields.push(importField);
                }
                return this.$q.when();
            });
    }
    mapFields():boolean{
        this.entities = [];
        for (var i = 0; i < this.csvData.length; i++) {
            var item = this.csvData[i];
            var entity:any = new Asset();
            for (var j = 0; j < this.requiredImportFields.length; j++) {
                var importField = this.requiredImportFields[j];
                if(importField.selectedValue === null || importField.selectedValue === "")
                  return false;
                entity[importField.fieldName] = item[importField.selectedValue];
            }
            for (var j = 0; j < this.optionalImportFields.length; j++) {
                var importField = this.optionalImportFields[j];
                entity[importField.fieldName] = item[importField.selectedValue];
            }
            this.entities.push(entity);
        }
        return true;
    }
    doImport(test:boolean):ng.IPromise<boolean>{
        return this.importService.import(this.entities,test).then((data)=>{
            this.errorEntities = [];
            this.okEntities = [];
            this.errors = [];
            for(var i=0;i<data.length;i++){
                if(data[i].length > 0){
                    this.errorEntities.push(this.entities[i]);
                    this.errors.push(data[i]);
                }
                else{
                    this.okEntities.push(this.entities[i]);
                }
            }
            this.errorsCount = this.errorEntities.length;
            return this.$q.when<boolean>(this.errorEntities.length == 0);
        });
    }
    getRoute(nextAction:any):string{
        return "";
    }

}
